import type { Server, TerminalHost } from "@cloudserver/contracts";
import { isWindowsServer } from "../ui/os.js";
import { serverBlock } from "./store.js";

/**
 * What a click on a server in the "Connect to server" picker (or its
 * server page's «Терминал») does:
 * - `blocked`: nothing (the server is off or has no public address);
 * - `direct`: connects at once with a certificate as `unixUser` (the user
 *   remembered for the server, root by default) — the server's certificate
 *   sign-in is known to work;
 * - `signIn`: the step with the user and how to sign in, as before. Always
 *   for Windows servers, whose default is the remote desktop.
 */
export type PickerChoice =
  | { kind: "blocked"; reason: "off" | "noAddress" }
  | { kind: "direct"; unixUser: string }
  | { kind: "signIn" };

export function pickerChoice(
  server: Pick<Server, "id" | "status" | "publicIpv4" | "publicIpv6"> &
    Partial<Pick<Server, "image" | "labels">>,
  hosts: readonly TerminalHost[] | undefined,
  rememberedUser: (serverId: string) => string,
): PickerChoice {
  const reason = serverBlock(server);
  if (reason) return { kind: "blocked", reason };
  if (isWindowsServer(server)) return { kind: "signIn" };
  const known = hosts?.find((host) => host.serverId === server.id);
  if (known?.certificateWorkedAt) return { kind: "direct", unixUser: rememberedUser(server.id) };
  return { kind: "signIn" };
}
